import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  paddingInline: '25rem',

  [theme.breakpoint.media.minMf.md]: {
    borderLeft: `1rem solid ${theme.palette.erieBlack}`,
    width: '40%',
  },
}));

export const ImageWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
});

export const Title = styled.h3(({ theme }) => ({
  lineHeight: '1.5',
  wordWrap: 'break-word',
  color: theme.palette.artichoke,
  fontFamily: theme.typography.family.playfairDisplay,
  textTransform: 'uppercase',
  fontSize: theme.typography.size24,
  fontWeight: 500,
}));

export const Image = styled.img({
  maxWidth: '100%',
  height: 'auto',
});

export const Price = styled.p(({ theme }) => ({
  lineHeight: '1.5',
  wordWrap: 'break-word',
  color: theme.palette.artichoke,
  fontFamily: theme.typography.family.playfairDisplay,
  textTransform: 'uppercase',
  fontSize: theme.typography.size24,
  fontWeight: 500,
  marginBottom: 0,
}));

export const PriceWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
});
